module.exports = __webpack_public_path__ + "static/media/Slow_Motor_Function_Control_Reinforcement.b470c110.mp3";